import {FiTrash2,FiSearch,FiX,FiMessageCircle,FiLayers,FiArrowUpRight,FiChevronLeft,FiChevronRight,FiMinimize2,FiMaximize2,FiBarChart2,FiPlay,FiPause,FiSquare,FiMaximize,FiSliders,FiMoreHorizontal,FiPlus} from 'react-icons/fi';
import {waveformAssistEnabled} from '../lib/boundaryFeature';
import {assistWaveformPassages} from '../lib/waveformAssist.js';
import React,{useEffect,useLayoutEffect,useMemo,useRef,useState} from 'react';
import Transcript from './Transcript';
import StoryRuntimeBar from './StoryRuntimeBar';
import FeedbackInbox from './FeedbackInbox';
import {storyRuntime} from '../lib/storyRuntime';
import StoryOverview from './StoryOverview';
import StoryCommentsPanel from './StoryCommentsPanel';
import {feedbackSourceRange} from '../lib/feedbackInbox';
import {applyDraftOrdering} from '../lib/clientStoryDraft';
import {selectionInParagraph,storyAnchor,storyExcerpt,chars} from '../lib/storyAnchors';
import {reviewRpc} from '../lib/clientReview';
import supabase from '../supabase/supabase';
import {projectInterviews} from '../lib/projectWorkspace';
import MeaningSearch from './MeaningSearch';
import StoryDraft from './StoryDraft';
import StorySectionHeading from './StorySectionHeading';
import StoryFlowPanel from './StoryFlowPanel';
import AiCleanup from './AiCleanup';
import AssemblyCutSwitcher from './AssemblyCutSwitcher';
import AssemblyCutHistory from './AssemblyCutHistory';
import {readAssemblyCuts,activeCutName} from '../lib/assemblyCuts.js';
import {checkpointBeforeAiChange} from '../lib/storyVersions';
import {addStorySection,renameStorySection,moveStorySection,removeStorySection,removeStoryPassage,placeStorySection,placeStorySectionBeside} from '../lib/storySections';
import FindSelectsButton from './FindSelectsButton';
import InterviewToolbar from './InterviewToolbar';
import {sourceSnapshot,addPassages,insertNewPassages,movePassage} from '../lib/paperEdit';
import {storySourceDisplayName} from '../lib/interviewNames';
import {formatTime} from '../lib/editModel';
import {buildPaperPdf,paperPdfFilename} from '../lib/paperPdf';
import {downloadFile} from '../lib/exports';
import {markSourceWords,sourceWordPriority} from '../lib/storyPriority';
import {indexStoryComments} from '../lib/storyCommentIndex';
import {PrecisePreview} from '../lib/precisePreview';
import {waitForVideoReady,reachedNativePassageEnd} from '../lib/nativeAssemblyPlayback.js';
import {isStoryPassageSpace,assemblyFromPassage} from '../lib/storyPassageKeyboard';
import useLayoutPreference from '../hooks/useLayoutPreference';
import {interviewColour,passageWords,sourceColourOrder,storyWordIds} from '../lib/storyContext';
import {primePaperPaste,playPaperPaste} from '../lib/paperPasteSound';
import {capturePassageRects,animatePassageReorder} from '../lib/passageMotion';
import {passageInsertSlot,passageReorderTarget} from '../lib/storyPointerReorder';
import {createFloatingPassageDrag} from '../lib/floatingPassageDrag';
import {cachedPrivateMediaUrl} from '../lib/privateMediaUrlCache';

const empty={sources:{},blocks:[]};
export default function PaperEdit({project,rows,activeId,sourceId,onSourceChange,onChange,getUrl,onError,getAccessToken,projectTitle,playbackControlRef,storyProjectId,onSelectInterview=onSourceChange,findSelectsOpen=false,onFindSelectsChange=()=>{},findButtonRef,onImport,onTranscribe,busy,processingId,processingText,signedIn,onSignIn,localUrl,onRecoverStory,onRefine=()=>{},onBeforeCutSwitch=async()=>{},feedbackOpen=false,reviewRefreshKey=0,onFeedbackOpenChange=()=>{},onAcceptFeedback,onManageReview=()=>{},onStartReview=onManageReview,onRenameSpeaker=()=>{},onCleanupSource=async()=>{}}) {
  const paper=project.paperEdit || empty;
  const [previewCollapsed,setPreviewCollapsed]=useLayoutPreference('cutscript.previewCollapsed');
  const [selectsCollapsed,setSelectsCollapsed]=useLayoutPreference('takefold.selectsCollapsed');
  const [assemblyCollapsed,setAssemblyCollapsed]=useLayoutPreference('takefold.assemblyCollapsed');
  const [feedbackOpenCount,setFeedbackOpenCount]=useState(0);
  useEffect(()=>{if(selectsCollapsed&&assemblyCollapsed)setAssemblyCollapsed(false);},[selectsCollapsed,assemblyCollapsed,setAssemblyCollapsed]);
  const [statsCollapsed,setStatsCollapsed]=useLayoutPreference('takefold.statsCollapsed.v2',true);
  const [nativePlaying,setNativePlaying]=useState(false),[mediaDuration,setMediaDuration]=useState(0);
  const playerFrame=useRef(null);
  const [videoFullscreen,setVideoFullscreen]=useState(false);
  useEffect(()=>{
    const handleFullscreen=()=>setVideoFullscreen(document.fullscreenElement===playerFrame.current);
    document.addEventListener('fullscreenchange',handleFullscreen);
    return()=>document.removeEventListener('fullscreenchange',handleFullscreen);
  },[]);
  const exploreOpen=findSelectsOpen;
  const setExploreOpen=onFindSelectsChange;
  const lastLeftRequest=useRef({feedback:false,assistant:false});
  useEffect(()=>{
    if((feedbackOpen&&!lastLeftRequest.current.feedback)||(exploreOpen&&!lastLeftRequest.current.assistant))setSelectsCollapsed(false);
    lastLeftRequest.current={feedback:feedbackOpen,assistant:exploreOpen};
  },[feedbackOpen,exploreOpen,setSelectsCollapsed]);
  const searchInput=useRef(null);
  const [searchOpen,setSearchOpen]=useState(false);
  const [transcriptMoreOpen,setTranscriptMoreOpen]=useState(false);
  useEffect(()=>{
    if(searchOpen)requestAnimationFrame(()=>searchInput.current?.focus());
  },[searchOpen]);
  const [addedNotice,setAddedNotice]=useState('');
  const [addedGlowWords,setAddedGlowWords]=useState([]);
  const [insertBefore,setInsertBefore]=useState(null);
  useEffect(()=>{if(insertBefore!==null && insertBefore>paper.blocks.length)setInsertBefore(null);},[insertBefore,paper.blocks.length]);
  const [storyDraftOpen,setStoryDraftOpen]=useState(false);
  const [flowOpen,setFlowOpen]=useState(false);
  const [flowPreview,setFlowPreview]=useState(null);
  const [historyOpen,setHistoryOpen]=useState(false);
  const [storyMoreOpen,setStoryMoreOpen]=useState(false);
  const storyMoreRef=useRef(null);
  const [newSectionId,setNewSectionId]=useState(null);
  const [recentlyAdded,setRecentlyAdded]=useState([]);
  useEffect(()=>{if(!addedNotice)return;const timer=setTimeout(()=>setAddedNotice(''),4000);return()=>clearTimeout(timer);},[addedNotice]);
  useEffect(()=>{
    if(!storyMoreOpen)return;
    const closeOutside=event=>{if(!storyMoreRef.current?.contains(event.target))setStoryMoreOpen(false);};
    const closeEscape=event=>{if(event.key==='Escape')setStoryMoreOpen(false);};
    document.addEventListener('pointerdown',closeOutside);
    document.addEventListener('keydown',closeEscape);
    return()=>{document.removeEventListener('pointerdown',closeOutside);document.removeEventListener('keydown',closeEscape);};
  },[storyMoreOpen]);
  useEffect(()=>{
    if(!recentlyAdded.length)return;
    // No forced jump when collecting a new passage: preserve reading position.
    const timeout=setTimeout(()=>setRecentlyAdded([]),950);
    return()=>clearTimeout(timeout);
  },[recentlyAdded]);
  useEffect(()=>{if(!addedGlowWords.length)return;const t=setTimeout(()=>setAddedGlowWords([]),850);return()=>clearTimeout(t);},[addedGlowWords]);
  const [pendingJump,setPendingJump]=useState(null);
  const transcriptPanel=useRef(null);
  const [split,setSplit]=useState(()=>{try{const value=Number(localStorage.getItem('cutscript.paperSplit'));return value>=35 && value<=65?value:55;}catch{return 55;}});
  const columns=useRef(null),resizing=useRef(false);
  const changeSplit=value=>setSplit(Math.max(35,Math.min(65,value)));
  useEffect(()=>{try{localStorage.setItem('cutscript.paperSplit',String(split));}catch{/* Layout remains usable without storage. */}},[split]);
  const closeExplore=()=>{setExploreOpen(false);findButtonRef?.current?.focus();};
  const resizeFromPointer=e=>{const rect=columns.current?.getBoundingClientRect();if(rect)changeSplit((e.clientX-rect.left)/rect.width*100);};
  const [meaningMatches,setMeaningMatches]=useState([]);
  const [selected,setSelected]=useState([]),[anchor,setAnchor]=useState(null),[search,setSearch]=useState('');
  const [playbackScope,setPlaybackScope]=useState('interview');
  const [previewSourceId,setPreviewSourceId]=useState(sourceId);
  const [url,setUrl]=useState(''),[currentTime,setCurrentTime]=useState(0),[status,setStatus]=useState(''),[playingId,setPlayingId]=useState(null);
  // Some private media URLs can stream in <video> but reject script fetches.
  // Once detected, skip redundant audio decode retries for that interview.
  const nativeAssemblySources=useRef(new Set());
  const [previewError,setPreviewError]=useState('');
  const [activeBlockId,setActiveBlockId]=useState(null),[dropIndex,setDropIndex]=useState(null);
  const [storyFocus,setStoryFocus]=useState(null),[storySelection,setStorySelection]=useState(null);
  const [storyComments,setStoryComments]=useState([]),[selectedStoryComment,setSelectedStoryComment]=useState(null);
  const {byBlock:storyCommentsByBlock,openCounts:storyOpenCommentCounts,byId:storyCommentsById}=
    useMemo(()=>indexStoryComments(storyComments),[storyComments]);
  const storyCommentsForBlock=id=>storyCommentsByBlock.get(id)||[];
  const [marginOpen,setMarginOpen]=useState(null);
  useEffect(()=>{
    if(!marginOpen)return;
    const outside=event=>{
      if(!event.target.closest?.('.paper-margin-comment-popover,.paper-margin-comment-marker,.passage-comment-button')){
        setMarginOpen(null);setStoryFocus(null);setSelectedStoryComment(null);
      }
    };
    const escape=event=>{if(event.key==='Escape'){setMarginOpen(null);setStoryFocus(null);setSelectedStoryComment(null);}};
    document.addEventListener('pointerdown',outside,true);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('pointerdown',outside,true);document.removeEventListener('keydown',escape);};
  },[marginOpen]);
  const storyCommentCall=(action,payload={})=>reviewRpc(supabase,'cutscript_story_comment_owner',{p_project:storyProjectId||activeId,p_action:action,p_payload:payload});
  const selectedRuntime=paper.targetRuntimeSeconds;
  const setRuntimeTarget=value=>save({...paper,targetRuntimeSeconds:value});
  useEffect(()=>{
    let live=true;
    if(!storyProjectId&&!activeId)return;
    const update=()=>storyCommentCall('list').then(data=>{if(live)setStoryComments(data.comments||[]);}).catch(()=>{});
    update();
    const interval=setInterval(()=>{if(document.visibilityState!=='hidden')update();},25000);
    return()=>{live=false;clearInterval(interval);};
  },[storyProjectId,activeId]);
  const captureStorySelection=(event,block)=>{
    if(event.target?.closest?.('button,input,textarea,select'))return;
    const p=event.currentTarget.querySelector('.paper-comment-text');
    const chosen=selectionInParagraph(p);
    if(!chosen){setStorySelection(null);return;}
    const rectangle=window.getSelection().getRangeAt(0).getBoundingClientRect();
    const card=event.currentTarget.getBoundingClientRect();
    setActiveBlockId(block.id);
    setStorySelection({blockId:block.id,...chosen,
      left:Math.max(10,Math.min(card.width-115,rectangle.left-card.left)),
      top:Math.max(2,rectangle.top-card.top-43)});
  };
  const beginStoryComment=(block,anchor)=>{
    const selected=anchor||storyAnchor(block.text,0,chars(block.text).length);
    if(!selected)return;
    setActiveBlockId(block.id);
    setStoryFocus({blockId:block.id,sourceTitle:sourceName(block.sourceId),...selected});
    setSelectedStoryComment(null);
    setStorySelection(null);
    window.getSelection()?.removeAllRanges();
    setMarginOpen(block.id);
    onFeedbackOpenChange(false);
  };
  const navigateStoryComment=comment=>{
    if(!comment){setSelectedStoryComment(null);return;}
    setAssemblyCollapsed(false);
    setSelectedStoryComment(comment.id);setMarginOpen(comment.block_id);setActiveBlockId(comment.block_id);
    const card=[...(columns.current?.querySelectorAll('[data-passage-id]')||[])].find(el=>el.dataset.passageId===comment.block_id);
    card?.scrollIntoView({behavior:'smooth',block:'nearest'});
  };
  const [draggingId,setDraggingId]=useState(null);
  const [headingDrop,setHeadingDrop]=useState(null);
  const reorderPositions=useRef(null),reorderAnimations=useRef([]);
  const safeFlowPreview=Array.isArray(flowPreview)&&flowPreview.length===paper.blocks.length&&
    new Set(flowPreview).size===paper.blocks.length&&flowPreview.every(id=>paper.blocks.some(block=>block.id===id));
  const shownBlocks=safeFlowPreview?flowPreview.map(id=>paper.blocks.find(block=>block.id===id)):paper.blocks;
  const closeFlow=()=>{setFlowOpen(false);setFlowPreview(null);};
  const activeIndex=paper.blocks.findIndex(b=>b.id===activeBlockId);
  const activeBlock=paper.blocks[activeIndex];
  const reorder=(from,to,animate=true)=>{
    if(from===to || from<0 || to<0 || from>=paper.blocks.length || to>=paper.blocks.length)return;
    // Snapshot existing positions before React replaces the block order.
    // Both the moved slip and its neighbours will glide into their new slots.
    for(const animation of reorderAnimations.current)animation.cancel();
    reorderAnimations.current=[];
    reorderPositions.current=animate?capturePassageRects(columns.current?.querySelector('.paper-blocks')):null;
    setActiveBlockId(paper.blocks[from].id);
    save(movePassage(paper,from,to));
  };
  const storyList=()=>columns.current?.querySelector('.paper-blocks');
  const pointerDropSlot=y=>{
    const list=storyList();
    if(!list)return 0;
    // While lifted, do not hit-test animated row boxes: the shared visual
    // projection holds the original row positions steady until the drop.
    const preview=drag.current?.preview;
    if(preview){
      const {slot}=preview.update(drag.current.x, y);
      drag.current.slot=slot;return slot;
    }
    const rects=[...list.querySelectorAll('[data-passage-id]')].map(node=>node.getBoundingClientRect());
    const slot=passageInsertSlot(rects,y);
    if(drag.current)drag.current.slot=slot;
    setDropIndex(previous=>previous===slot?previous:slot);
    return slot;
  };
  const beginPassagePointer=(event,index,id)=>{
    if(busy||event.button!==0||event.isPrimary===false||headingDrag.current)return;
    event.preventDefault();event.stopPropagation();
    drag.current={pointerId:event.pointerId,index,id,startX:event.clientX,startY:event.clientY,
      x:event.clientX,y:event.clientY,slot:index,started:false,preview:null};
    event.currentTarget.setPointerCapture(event.pointerId);
    // Selecting on pointer-down can insert the contextual "Show in transcript"
    // control into a quote and change its height before a drag begins.
    // Click handles tap selection; successful reorders select on drop instead.
  };
  const passageAutoScroll=()=>{
    const state=drag.current;
    if(!state?.started){passageScrollFrame.current=null;return;}
    const list=storyList();
    if(list){
      const bounds=list.getBoundingClientRect(),edge=42;
      let delta=0;
      if(state.y<bounds.top+edge)delta=-Math.min(17,(bounds.top+edge-state.y)*.45);
      else if(state.y>bounds.bottom-edge)delta=Math.min(17,(state.y-(bounds.bottom-edge))*.45);
      if(delta)list.scrollTop+=delta;
      pointerDropSlot(state.y);
    }
    passageScrollFrame.current=requestAnimationFrame(passageAutoScroll);
  };
  const movePassagePointer=event=>{
    const state=drag.current;
    if(!state||event.pointerId!==state.pointerId)return;
    if(!state.started){
      if(Math.hypot(event.clientX-state.startX,event.clientY-state.startY)<6)return;
      state.started=true;
      state.preview=createFloatingPassageDrag(storyList(),
        event.currentTarget.closest('[data-passage-id]'),state.index,event.clientX,event.clientY);
      setDraggingId(state.id);
      if(passageScrollFrame.current===null)
        passageScrollFrame.current=requestAnimationFrame(passageAutoScroll);
    }
    state.x=event.clientX;state.y=event.clientY;
    event.preventDefault();event.stopPropagation();
    pointerDropSlot(event.clientY);
  };
  const endPassagePointer=(event,cancel=false)=>{
    const state=drag.current;
    if(!state||event.pointerId!==state.pointerId)return;
    const moved=state.started;
    const slot=moved&&!cancel?pointerDropSlot(event.clientY):null;
    const destination=slot===null?null:passageReorderTarget(state.index,slot,paper.blocks.length);
    state.preview?.finish();
    drag.current=null;
    stopPassageScroll();setDraggingId(null);setDropIndex(null);
    if(event.currentTarget.hasPointerCapture?.(event.pointerId))
      event.currentTarget.releasePointerCapture(event.pointerId);
    if(moved){event.preventDefault();event.stopPropagation();}
    if(destination!==null&&destination!==state.index)reorder(state.index,destination,false);
  };
  useLayoutEffect(()=>{
    const previous=reorderPositions.current;
    if(!previous)return;
    reorderPositions.current=null;
    const reducedMotion=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    reorderAnimations.current=animatePassageReorder(
      columns.current?.querySelector('.paper-blocks'),previous,{reducedMotion}
    );
  },[paper.blocks]);
  useEffect(()=>()=>{for(const animation of reorderAnimations.current)animation.cancel();},[]);
  const passageScrollFrame=useRef(null);
  const stopPassageScroll=()=>{
    if(passageScrollFrame.current!==null)cancelAnimationFrame(passageScrollFrame.current);
    passageScrollFrame.current=null;
  };
  useEffect(()=>()=>{stopPassageScroll();drag.current?.preview?.destroy();drag.current=null;},[]);
  const urlCache=useRef(new Map());
  const mediaUrl=(sourceRow,force=false)=>cachedPrivateMediaUrl(urlCache.current,sourceRow,getUrl,{force});
  const mediaRecovery=useRef({sourceId:'',attemptAt:0,busy:false});
  const mediaResume=useRef(null);
  const video=useRef(null),engine=useRef(null),ticket=useRef(0),animation=useRef(null),drag=useRef(null),headingDrag=useRef(null),feedbackStopAt=useRef(null);
  const interviews=projectInterviews(rows,activeId);
  const colourSourceIds=sourceColourOrder(paper.sourceColourOrder,[
    ...interviews.map(interview=>interview.id),...Object.keys(paper.sources||{})
  ]);
  const storySourceCounts=new Map();
  for(const block of paper.blocks)storySourceCounts.set(block.sourceId,(storySourceCounts.get(block.sourceId)||0)+1);
  const storyLegendIds=colourSourceIds.filter(id=>storySourceCounts.has(id));
  const sourceName=id=>storySourceDisplayName(interviews.find(r=>r.id===id),paper.sources[id]);
  const paperWithCurrentNames=()=>({...paper,
    sources:Object.fromEntries(Object.entries(paper.sources||{}).map(([id,saved])=>[id,{...saved,title:sourceName(id)}]))
  });
  const row=interviews.find(r=>r.id===sourceId);
  const source=row?.media_ready && row.data.words?.length ? sourceSnapshot(row) : null;
  // Preserve the same per-transcript cache reset without serialising every
  // transcript word on unrelated editor renders (playback, resize, comments).
  const findSources=interviews.filter(item=>item.media_ready&&item.data.words?.length).map(item=>({
    ...sourceSnapshot(item),speakerNames:item.data.speakerNames||{}
  }));
  const usedWordIds=useMemo(()=>storyWordIds(row?.data.words || [],paper.blocks,sourceId),[row?.data.words,paper.blocks,sourceId]);
  useEffect(()=>{if(!source)setExploreOpen(false);},[!!source]);
  const earlierStories=interviews.filter(r=>r.id!==activeId && r.data.paperEdit?.blocks?.some(b=>!paper.blocks.some(current=>current.id===b.id)));
  const readyCount=interviews.filter(r=>r.media_ready && r.data.words?.length).length;
  const save=next=>onChange({...project,paperEdit:{...next,sourceColourOrder:colourSourceIds}});
  const addSection=()=>{
    const id=crypto.randomUUID();
    const at=activeIndex>=0?activeIndex+1:paper.blocks.length;
    save(addStorySection(paper,at,'New section',()=>id));setNewSectionId(id);
  };
  const endHeadingDrag=()=>{
    headingDrag.current=null;
    setDraggingId(null);setHeadingDrop(null);setDropIndex(null);
  };
  const placeHeadingInGap=beforeIndex=>{
    const id=headingDrag.current;
    if(!id)return;
    save(placeStorySection(paper,id,beforeIndex));
    setNewSectionId(null);endHeadingDrag();
  };
  const renderSections=at=>(paper.sectionHeadings||[]).filter(section=>section.beforeIndex===at).map(section=><StorySectionHeading key={section.id} section={section}
    maxIndex={paper.blocks.length} initialFocus={newSectionId===section.id}
    dragging={headingDrag.current===section.id}
    dropSide={headingDrop?.id===section.id?headingDrop.side:null}
    onDragStart={(event,id)=>{
      if(busy){event.preventDefault();return;}
      headingDrag.current=id;drag.current=null;stopPassageScroll();
      setDraggingId('heading:'+id);setHeadingDrop(null);setDropIndex(null);
      event.dataTransfer.effectAllowed='move';
      event.dataTransfer.setData('text/plain','takefold-heading:'+id);
    }}
    onDragOver={(event,id)=>{
      if(!headingDrag.current||headingDrag.current===id)return;
      event.preventDefault();event.stopPropagation();
      event.dataTransfer.dropEffect='move';
      const rect=event.currentTarget.getBoundingClientRect();
      const side=event.clientY>rect.top+rect.height/2?'after':'before';
      setHeadingDrop({id,side});setDropIndex(null);
    }}
    onDrop={(event,id)=>{
      if(!headingDrag.current)return;
      event.preventDefault();event.stopPropagation();
      const rect=event.currentTarget.getBoundingClientRect();
      const after=event.clientY>rect.top+rect.height/2;
      save(placeStorySectionBeside(paper,headingDrag.current,id,after));
      setNewSectionId(null);endHeadingDrag();
    }}
    onDragEnd={endHeadingDrag}
    onRename={(id,title)=>{save(renameStorySection(paper,id,title));setNewSectionId(null);}}
    onMove={(id,direction)=>{save(moveStorySection(paper,id,direction));setNewSectionId(null);}}
    onRemove={id=>{save(removeStorySection(paper,id));setNewSectionId(null);}}/>);
  const adding=useRef(false),latestEdit=useRef(null);
  latestEdit.current={project,sourceId,words:row?.data.words};
  useEffect(()=>()=>{latestEdit.current=null;},[]);
  const addFoundSelect=async match=>{
    if(adding.current||busy||!activeId)throw new Error('Finish saving this project before adding a select.');
    const target=interviews.find(r=>r.id===match.sourceId&&r.media_ready&&r.data.words?.length);
    if(!target)throw new Error('The selected interview is no longer available.');
    const snapshot=sourceSnapshot(target),words=match.words||[];
    const ids=words.map(w=>w.id);
    if(!ids.length||!ids.every(id=>snapshot.words.some(w=>w.id===id)))
      throw new Error('This result no longer matches the source transcript. Search again.');
    adding.current=true;primePaperPaste();
    try{
      let appended=addPassages(paper,snapshot,ids);
      if(appended.blocks.length<=paper.blocks.length)throw new Error('This select could not be added.');
      if(waveformAssistEnabled){
        setStatus('Checking speech boundaries…');
        const newIds=appended.blocks.slice(paper.blocks.length).map(part=>part.id);
        appended=await assistWaveformPassages(appended,newIds,()=>mediaUrl(target));
      }
      const newIds=appended.blocks.slice(paper.blocks.length).map(block=>block.id);
      const next=insertNewPassages(paper,appended,insertBefore);
      save(checkpointBeforeAiChange(paper,next,'AI Find Selects'));
      setRecentlyAdded(newIds);
      setActiveBlockId(newIds.at(-1));
      setInsertBefore(slot=>slot===null?null:slot+newIds.length);
      if(sourceId===snapshot.id)setAddedGlowWords(ids);
      setAddedNotice('');
      playPaperPaste();
    }finally{adding.current=false;setStatus('');}
  };
  const previewFoundSelect=(match,onEnd)=>{
    const target=interviews.find(r=>r.id===match.sourceId&&r.media_ready&&r.data.words?.length);
    if(!target)throw new Error('This interview is unavailable.');
    const snapshot=sourceSnapshot(target),ids=match.words.map(w=>w.id);
    if(!ids.every(id=>snapshot.words.some(w=>w.id===id)))
      throw new Error('This source transcript changed. Search again.');
    const draft=addPassages(empty,snapshot,ids);
    if(!draft.blocks.length)throw new Error('This passage has no valid playback range.');
    setPreviewCollapsed(false);
    preview(draft.blocks,'selection');
    findSelectEndRef.current=onEnd;
  };
  const collectPassages=async (ids,{aiSelects=false}={})=>{
    if(adding.current || busy || !source || !ids.length)return;
    if(!activeId){onError('Save the current interview to cloud before collecting passages.');return;}
    primePaperPaste();
    const snapshot=latestEdit.current;
    const stillCurrent=()=>latestEdit.current?.project===snapshot.project && latestEdit.current?.sourceId===snapshot.sourceId && latestEdit.current?.words===snapshot.words;
    adding.current=true;
    try{
      let appended=addPassages(paper,source,ids);
      if(waveformAssistEnabled){
        setStatus('Checking speech boundaries…');
        const newIds=appended.blocks.slice(paper.blocks.length).map(part=>part.id);
        appended=await assistWaveformPassages(appended,newIds,()=>mediaUrl(row));
      }
      if(!stillCurrent())return;
      const count=appended.blocks.length-paper.blocks.length;
      if(count<=0){setStatus('Select at least one new word to add.');return;}
      const newIds=appended.blocks.slice(paper.blocks.length).map(block=>block.id);
      const next=insertNewPassages(paper,appended,insertBefore);
      save(aiSelects?checkpointBeforeAiChange(paper,next,'AI Find Selects'):next);setSelected([]);
      setRecentlyAdded(newIds);
      setActiveBlockId(newIds.at(-1));
      setInsertBefore(slot=>slot===null?null:slot+count);
      setAddedGlowWords(ids);
      playPaperPaste();
      setAddedNotice('');
      transcriptPanel.current?.querySelector('.transcript-body')?.focus({preventScroll:true});
    }catch(e){if(stillCurrent())onError(`Passage was not added: ${e.message}. Your selection is retained; please retry.`);}
    finally{adding.current=false;if(stillCurrent())setStatus('');}
  };
  const findSelectEndRef=useRef(null);
  const stop=()=>{const ended=findSelectEndRef.current;findSelectEndRef.current=null;ended?.();feedbackStopAt.current=null;ticket.current++;engine.current?.dispose();engine.current=null;video.current?.pause();if(video.current)video.current.muted=false;cancelAnimationFrame(animation.current);setPlayingId(null);setPlaybackScope('interview');setStatus('');};
  useEffect(()=>{stop();},[paper]);
  useEffect(()=>{
    mediaResume.current=null;
    stop();setMeaningMatches([]);setSelected([]);setAnchor(null);setCurrentTime(0);setUrl('');setPreviewError('');
    const request=ticket.current;
    if(row?.media_ready)void mediaUrl(row).then(value=>{
      if(request===ticket.current){
        setUrl(value);setPreviewSourceId(sourceId);setPreviewError('');
        if(video.current)video.current.muted=false;
      }
    }).catch(error=>{
      // A playback failure is not a failed Assembly save.
      if(request===ticket.current)setPreviewError(error?.message||'Video link unavailable.');
    });
    return()=>{ticket.current++;};
  },[sourceId,row?.media_path,row?.media_ready]);
  useEffect(()=>()=>{ticket.current++;cancelAnimationFrame(animation.current);engine.current?.dispose();},[]);
  const retryPreview=()=>{
    if(!row?.media_ready)return;
    const request=ticket.current;
    setPreviewError('');
    void mediaUrl(row,true).then(value=>{
      if(request!==ticket.current)return;
      setUrl(value);setPreviewSourceId(sourceId);
      if(video.current)video.current.muted=false;
    }).catch(error=>{
      if(request===ticket.current)setPreviewError(error?.message||'Video link unavailable.');
    });
  };
  // Cloudflare R2 playback signatures last one hour. A tab left open may
  // still hold a stale <video> src even after our short URL cache expires.
  // Renew at most once per source each minute; do not loop on corrupt files.
  const recoverVideoError=()=>{
    const player=video.current;
    const failedSource=interviews.find(item=>item.id===previewSourceId && item.media_ready);
    if(!player || !activeId || !failedSource){
      onError('Video preview could not play. Check the video format or reconnect the source.');
      return;
    }
    const now=Date.now(),previous=mediaRecovery.current;
    if(previous.busy)return;
    if(previous.sourceId===failedSource.id && now-previous.attemptAt<60_000){
      setStatus('');
      onError('Video preview still cannot load after renewing access. Check your connection or video format, then try selecting the interview again.');
      return;
    }
    const resumeAt=Number.isFinite(player.currentTime)?player.currentTime:0;
    const resumePlaying=!player.paused && !playingId;
    if(playingId)stop(); // Stop the separate Assembly audio clock before reconnecting.
    const request=ticket.current;
    mediaRecovery.current={sourceId:failedSource.id,attemptAt:now,busy:true};
    setStatus('Renewing private video access…');
    void mediaUrl(failedSource,true).then(fresh=>{
      if(request!==ticket.current)return;
      const currentPlayer=video.current;
      if(!currentPlayer)return;
      mediaResume.current={request,sourceId:failedSource.id,time:resumeAt,playing:resumePlaying};
      setUrl(fresh);
      currentPlayer.src=fresh;
      currentPlayer.load();
    }).catch(error=>{
      if(request===ticket.current){
        mediaResume.current=null;
        setStatus('');
        onError('Could not renew video access. Check your connection and try reopening the interview. '+(error?.message||''));
      }
    }).finally(()=>{mediaRecovery.current.busy=false;});
  };
  const videoMetadataReady=()=>{
    const player=video.current;
    setMediaDuration(Number.isFinite(player?.duration)?player.duration:0);
    const resume=mediaResume.current;
    if(!player || !resume || resume.request!==ticket.current || resume.sourceId!==previewSourceId)return;
    mediaResume.current=null;
    setStatus('');
    if(Number.isFinite(resume.time)&&resume.time>0){
      try{player.currentTime=Math.min(resume.time,Number.isFinite(player.duration)?Math.max(0,player.duration-.1):resume.time);}catch{/* Media remains playable from the start. */}
    }
    if(resume.playing)void player.play().catch(()=>{});
  };
  const select=(word,shift,toggle)=>{
    stop();const index=source.words.findIndex(w=>w.id===word.id);
    if(shift && anchor!==null)setSelected(source.words.slice(Math.min(anchor,index),Math.max(anchor,index)+1).map(w=>w.id));
    else {setSelected(previous=>toggle ? previous.includes(word.id)?previous.filter(id=>id!==word.id):[...previous,word.id] : [word.id]);setAnchor(index);}
    setCurrentTime(word.start);
    const request=ticket.current;mediaUrl(row).then(value=>{if(request!==ticket.current)return;setUrl(value);setPreviewSourceId(sourceId);const player=video.current;if(!player)return;player.muted=false;if(player.src!==value){player.src=value;player.onloadedmetadata=()=>{player.currentTime=word.start;player.onloadedmetadata=null;};}else player.currentTime=word.start;}).catch(e=>onError(e.message));
  };
  const showInTranscript=block=>{
    const interview=interviews.find(item=>item.id===block.sourceId);
    if(!interview?.media_ready || !interview.data.words?.length){onError('This passage’s source transcript is unavailable. Restore the interview to view its original words.');return;}
    stop();setExploreOpen(false);setSearch('');setMeaningMatches([]);
    setSelectsCollapsed(false);
    setPendingJump({...block});onSourceChange(block.sourceId);
  };
  useEffect(()=>{
    if(!pendingJump || pendingJump.sourceId!==sourceId || !source)return;
    const words=passageWords(source.words,pendingJump);
    setPendingJump(null);
    if(!words.length){onError('No transcript words match this passage’s source timing. The interview may have been transcribed again.');return;}
    select(words[0],false,false);setSelected(words.map(word=>word.id));
    const request=ticket.current;
    // Wait until the source switch and transcript tab have rendered before focusing.
    requestAnimationFrame(()=>{
      if(request!==ticket.current)return;
      const word=[...(transcriptPanel.current?.querySelectorAll('[data-word-id]') || [])].find(el=>el.dataset.wordId===String(words[0].id));
      word?.scrollIntoView({block:'center',behavior:'smooth'});word?.focus({preventScroll:true});
    });
  },[pendingJump,sourceId,row?.data.words,row?.media_ready]);
  const playBlocks=async(blocks,index=0,request)=>{
    if(!blocks[index]){stop();return;}
    const block=blocks[index],saved=paper.sources[block.sourceId] || (source?.id===block.sourceId ? source : null);
    const media=rows.find(r=>r.id===block.sourceId && r.media_ready);
    if(!media){stop();onError('This interview is no longer available. Restore its source or remove the passage.');return;}
    setStatus('Preparing passage…');setPlayingId(block.id);
    let nextUrl;
    try{
      nextUrl=await mediaUrl(media);
      if(request!==ticket.current)return;
      setUrl(nextUrl);setPreviewSourceId(block.sourceId);
    }catch(error){
      if(request===ticket.current){
        stop();onError('Could not obtain the private video link for this passage. Check your connection or retry. '+(error?.message||''));
      }
      return;
    }
    const player=video.current;
    if(!player){if(request===ticket.current)stop();return;}
    // Exact source audio comes from small Mediabunny ranged reads. An opaque
    // browser video URL can still be played when WebCodecs/fetch is CORS-blocked.
    if(!nativeAssemblySources.current.has(block.sourceId)){
      try{
        if(!engine.current)engine.current=new PrecisePreview(new (window.AudioContext || window.webkitAudioContext)());
        await engine.current.prepare(nextUrl,saved?.duration||media.data.duration,block);
        if(request!==ticket.current)return;
        player.onloadedmetadata=null;
        if(player.src!==nextUrl)player.src=nextUrl;
        player.muted=true;player.currentTime=block.start;
        await player.play();
        if(request!==ticket.current){player.pause();return;}
        engine.current.start([block],block.start,true);
        setStatus(`Playing ${index+1} of ${blocks.length}`);
        const tick=()=>{
          if(request!==ticket.current)return;
          const pos=engine.current?.position();if(!pos)return;
          setCurrentTime(pos.source);
          if(!player.seeking&&Math.abs(player.currentTime-pos.source)>.12)player.currentTime=pos.source;
          if(pos.ended){engine.current.stop();player.pause();void playBlocks(blocks,index+1,request);return;}
          animation.current=requestAnimationFrame(tick);
        };tick();
        return;
      }catch(error){
        if(request!==ticket.current)return;
        // Don't raise a destructive-looking project banner for a *preview*
        // audio decode failure. Original media and Assembly trims are intact.
        nativeAssemblySources.current.add(block.sourceId);
        engine.current?.dispose();engine.current=null;
      }
    }
    try{
      setStatus('Preparing browser playback…');
      if(player.src!==nextUrl)player.src=nextUrl;
      await waitForVideoReady(player,block.start);
      if(request!==ticket.current)return;
      player.muted=false;
      await player.play();
      if(request!==ticket.current){player.pause();return;}
      setStatus(`Playing ${index+1} of ${blocks.length}`);
      const tick=()=>{
        if(request!==ticket.current)return;
        if(player.error){
          stop();onError('The video could not play in your browser. Try Retry video or reopen the interview.');
          return;
        }
        setCurrentTime(player.currentTime);
        if(reachedNativePassageEnd(player.currentTime,block.end,player.seeking)){
          player.pause();void playBlocks(blocks,index+1,request);return;
        }
        animation.current=requestAnimationFrame(tick);
      };tick();
    }catch(error){
      if(request===ticket.current){
        stop();onError('The browser could not play this interview video. Try the Play button or reopen the interview. '+(error?.message||''));
      }
    }
  };
  const preview=(blocks,scope='passage')=>{stop();setPlaybackScope(scope);playBlocks(blocks,0,ticket.current);};
  const auditionSelection=()=>{
    if(playingId){stop();return;}
    if(!source || !selected.length)return;
    const draft=addPassages(empty,source,selected);
    preview(draft.blocks,'selection');
  };
  const seekPreview=time=>{
    // The precise Assembly audio engine owns its clock during passage playback.
    if(playingId)return;
    const player=video.current;
    if(!player || !Number.isFinite(time) || !mediaDuration)return;
    const clamped=Math.max(0,Math.min(mediaDuration,time));
    player.currentTime=clamped;
    setCurrentTime(clamped);
  };
  const toggleVideoFullscreen=async()=>{
    const frame=playerFrame.current;
    if(!frame)return;
    try{
      if(document.fullscreenElement){await document.exitFullscreen();}
      else if(frame.requestFullscreen){await frame.requestFullscreen();}
      else if(video.current?.webkitEnterFullscreen){video.current.webkitEnterFullscreen();}
      else onError('Fullscreen is not supported by this browser.');
    }catch(err){onError(err.message || 'Could not enter fullscreen.');}
  };
  const toggleCompactPlayback=async()=>{
    // Space must play from the selected word onward, not stop after one selection.
    // The separate Preview selection action still auditions selected passages.
    if(playingId){stop();return;}
    const player=video.current;
    if(!player)return;
    if(!player.paused){player.pause();return;}
    try{await player.play();}catch(e){onError(e.message || 'Could not play this interview.');}
  };
  // Parent's Space shortcut shares this native-video toggle so it also works
  // when focus is outside the transcript. No forced source reloads on Space.
  if(playbackControlRef)playbackControlRef.current=toggleCompactPlayback;
  useEffect(()=>()=>{if(playbackControlRef)playbackControlRef.current=null;},[playbackControlRef]);
  const previewFeedback=async(note,context=0)=>{
    const range=feedbackSourceRange(note);
    const media=interviews.find(item=>item.id===note.source_id&&item.media_ready);
    if(!range||!media){onError('The source interview for this suggestion is unavailable.');return;}
    stop();
    const request=ticket.current;
    try{
      const signed=await mediaUrl(media);
      if(request!==ticket.current)return;
      const start=Math.max(0,range.start-context);
      const end=Math.min(media.data.duration||Infinity,range.end+context);
      feedbackStopAt.current=end;
      setUrl(signed);setPreviewSourceId(media.id);setPlaybackScope('interview');
      setStatus(context?'Playing client suggestion with 5-second context':'Playing client suggestion');
      setPreviewCollapsed(false);
      const player=video.current;
      if(!player)return;
      player.muted=false;
      const begin=()=>{if(request!==ticket.current)return;player.currentTime=start;setCurrentTime(start);player.play().catch(err=>onError(err.message||'Press Play to hear this suggestion.'));};
      if(player.src!==signed){player.onloadedmetadata=()=>{player.onloadedmetadata=null;begin();};player.src=signed;}
      else if(player.readyState>=1)begin();
      else player.onloadedmetadata=()=>{player.onloadedmetadata=null;begin();};
    }catch(e){if(request===ticket.current)onError(e.message||'Could not load this interview.');}
  };
  const jumpFeedbackToTranscript=note=>{
    const range=feedbackSourceRange(note);
    if(!range){onError('This suggestion is missing its original word timing.');return;}
    onFeedbackOpenChange(false);
    showInTranscript({sourceId:note.source_id,start:range.start,end:range.end,text:note.quote});
  };
  const removePassage=(id,focusNext=false)=>{
    if(busy)return;
    const index=paper.blocks.findIndex(block=>block.id===id);if(index<0)return;
    const updated=removeStoryPassage(paper,id);
    const next=updated.blocks[Math.min(index,updated.blocks.length-1)];
    save(updated);setActiveBlockId(next?.id ?? null);
    if(focusNext)requestAnimationFrame(()=>{
      const list=columns.current?.querySelector('.paper-blocks');
      const target=[...(list?.querySelectorAll('[data-passage-id]') || [])].find(el=>el.dataset.passageId===next?.id);
      (target || list)?.focus({preventScroll:true});
    });
  };
  const jumpToStoryPassage=id=>{
    if(!paper.blocks.some(block=>block.id===id))return;
    setActiveBlockId(id);setStorySelection(null);
    requestAnimationFrame(()=>{
      const list=columns.current?.querySelector('.paper-blocks');
      const target=[...(list?.querySelectorAll('[data-passage-id]')||[])].find(el=>el.dataset.passageId===id);
      target?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
      target?.focus({preventScroll:true});
    });
  };
  return <section className="paper-workspace" aria-label="Paper edit workspace">

    {!activeId && <div className="paper-onboarding" role="status"><strong>{localUrl?'Your interview is ready to save':'Start your project'}</strong><p>{localUrl ? signedIn ? 'Saving your video. Your interview will appear here when the upload finishes.' : 'Sign in to save this interview and create its transcript.' : 'Add an MP4 or WebM interview. Beta limit: 24 MB and 15 minutes per interview.'}</p>{!signedIn && <button onClick={onSignIn}>Sign in to save your project</button>}</div>}
    {!!earlierStories.length && <details className="earlier-stories"><summary>Earlier saved assemblies ({earlierStories.length})</summary><p>These selects were saved on individual interviews before the project story update. Append them here to continue. The original versions are kept.</p>{earlierStories.map(r=><div key={r.id}><span>{r.data.title} · {r.data.paperEdit.blocks.length} passages</span><button disabled={busy} onClick={()=>onRecoverStory(r.data.paperEdit)}>Append to Assembly</button></div>)}</details>}
    <div className="paper-layout">
    <div className={`paper-columns${selectsCollapsed?' is-selects-collapsed':''}${assemblyCollapsed?' is-assembly-collapsed':''}`} ref={columns} style={{'--paper-left':`${split}fr`,'--paper-right':`${100-split}fr`}}>
      <div className="paper-interview" id="paper-interview-pane" style={interviewColour(sourceId,colourSourceIds)}>


    {!feedbackOpen && readyCount>0 && <section id="editor-find-selects-panel" role="region" tabIndex={0} className="paper-explore-panel" hidden={!exploreOpen} aria-label="AI editorial tools" onKeyDown={e=>{if(e.key==='Escape'){e.stopPropagation();closeExplore();}}}>
      <header className="paper-explore-heading"><span className="selects-scope">Find Selects <span aria-hidden="true">/</span> <strong>{findSources.length} interviews</strong></span><button type="button" aria-label="Close Edit Assistant" title="Close Edit Assistant" onClick={closeExplore}>×</button></header>
      <div className="paper-explore-body">
        <div className="paper-ai-workspace">
          <div className="paper-ai-selects">
            {findSources.length ? <MeaningSearch key={storyProjectId||activeId||'project'} source={source} sources={findSources}
             onMatches={setMeaningMatches} getAccessToken={getAccessToken}
             isAdded={match=>paper.blocks.some(b=>b.sourceId===match.sourceId&&b.start<=match.words[0].start&&b.end>=match.words.at(-1).end)}
             onPreview={previewFoundSelect} onStop={stop} onAdd={addFoundSelect}/> :
             <p className="paper-ai-no-source">Transcribe an interview first to find useful selects.</p>}
          </div>
          <aside className="paper-ai-story-panel" aria-labelledby="paper-ai-story-title">
            <div className="paper-ai-story-top">
              <span className="paper-ai-story-icon" aria-hidden="true"><FiLayers/></span>
              <span className="paper-ai-story-eyebrow">ALL INTERVIEWS</span>
            </div>
            <div className="paper-ai-story-copy">
              <h3 id="paper-ai-story-title">Complete Story</h3>
              <p>Let AI build a first paper edit from your interviews, ready for you to refine.</p>
            </div>
            <button type="button" className="paper-ai-story-action" onClick={()=>setStoryDraftOpen(true)}>
              Create with AI <FiArrowUpRight aria-hidden="true"/>
            </button>
          </aside>
        </div>
      </div>
    </section>}
        <div ref={transcriptPanel} id="paper-transcript-panel" className="paper-reading-panel" role="region" aria-label="Source transcript">
        {feedbackOpen ? <>
           <FeedbackInbox projectId={storyProjectId||activeId} paper={paper} refreshKey={reviewRefreshKey} onOpenCountChange={setFeedbackOpenCount} onAccept={onAcceptFeedback} onPreview={previewFeedback} onShowTranscript={jumpFeedbackToTranscript} onManageReview={onManageReview} onStartReview={onStartReview} onHide={()=>{onFeedbackOpenChange(false);setAssemblyCollapsed(false);}} onShowStory={comment=>{onFeedbackOpenChange(false);navigateStoryComment(comment);}}
          onApplyDraft={async(draft,options)=>{
            if(!window.confirm('Apply '+draft.guest_name+'\'s proposed order? The current Assembly will be saved as a named version first. No passages will be removed.'))return false;
            const next=applyDraftOrdering(paper,draft.sequence,options,draft.guest_name);
            if(next===paper)return false;
            save(next);setAddedNotice('Suggested order applied · recovery saved in History');return true;
          }} disabled={busy}
         /></> : <>
        <div className="section-heading paper-transcript-heading">
          <div className="paper-heading-primary">
            <h2>Interview transcript <span className="count">{source?.words.length || 0} words</span></h2>
            <InterviewToolbar inline interviews={interviews} selectedId={sourceId} onSelect={onSelectInterview} disabled={busy}/>
          </div>
          <div className="paper-heading-controls">{assemblyCollapsed
  ? <button type="button" className="editor-reveal-tab" aria-label="Show Assembly"
      title="Show Assembly" onClick={()=>setAssemblyCollapsed(false)}>
      <FiChevronRight aria-hidden="true"/>
    </button>
  : <button type="button" className="editor-pane-action hide-paper-edit" aria-label="Hide transcript"
      title="Hide interview transcript and enlarge Assembly" onClick={()=>{setAssemblyCollapsed(false);setSelectsCollapsed(true);}}>
      <FiChevronLeft aria-hidden="true"/>
    </button>}</div>
        </div>
        <div className="transcript-tools paper-transcript-tools">
          <div className={`paper-search-slot${searchOpen?' is-open':''}`}>
            {!searchOpen ? <button type="button" data-transcript-search className="paper-search-toggle"
              aria-label="Search transcript" aria-expanded={false} title="Search transcript · Ctrl/⌘ F"
              onClick={()=>setSearchOpen(true)}><FiSearch aria-hidden="true"/></button>
              : <div className="search compact-transcript-search">
                <FiSearch aria-hidden="true"/>
                <input ref={searchInput} aria-label="Search transcript" placeholder="Find a word or phrase…"
                  value={search} onChange={e=>setSearch(e.target.value)}
                  onKeyDown={e=>{if(e.key==='Escape'){e.preventDefault();e.stopPropagation();setSearch('');setSearchOpen(false);}}}/>
                <button type="button" aria-label="Close transcript search" title="Close search"
                  onClick={()=>{setSearch('');setSearchOpen(false);}}><FiX aria-hidden="true"/></button>
              </div>}
          </div>
          <FindSelectsButton open={exploreOpen} onToggle={()=>setExploreOpen(value=>!value)}
            available={readyCount>0} disabled={busy} buttonRef={findButtonRef} label="Find Selects" title="Find useful quotes across project interviews, then compare and audition takes"/>
          <button type="button" className="paper-toolbar-more" aria-label="More transcript tools"
            aria-expanded={transcriptMoreOpen} aria-controls="paper-transcript-secondary"
            title="More transcript tools, including AI Cleanup" onClick={()=>setTranscriptMoreOpen(open=>!open)}>
            <FiMoreHorizontal aria-hidden="true"/>
          </button>
        </div>
        {transcriptMoreOpen && <div className="paper-transcript-secondary" id="paper-transcript-secondary"
          role="region" aria-label="More transcript tools" onKeyDown={event=>{if(event.key==='Escape'){event.stopPropagation();setTranscriptMoreOpen(false);}}}>
          {source&&<AiCleanup key={source.id} source={{...source,cuts:row?.data?.cuts||[],clips:row?.data?.clips}}
            sourceId={source.id} priorityWordIds={sourceWordPriority(paper,source)}
            assemblyWordIds={usedWordIds} getAccessToken={getAccessToken}
            onApply={onCleanupSource} disabled={busy||!signedIn}
            onPreview={words=>{const next=addPassages(empty,source,words.map(w=>w.id));if(next.blocks.length)preview(next.blocks,'selection');}}/>}
        </div>}
        {source ? <Transcript compactHeader key={source.id} suspendSelectionMenu={storyDraftOpen || historyOpen || feedbackOpen} usedWordIds={usedWordIds} recentlyAddedWordIds={addedGlowWords} priorityWordIds={sourceWordPriority(paper,source)} onCycleSourcePriority={priority=>{save(markSourceWords(paper,source,selected,priority));setAddedNotice('Source priority updated');}} priorityBusy={busy} active={true} meaningMatches={meaningMatches} project={{...source,cuts:row?.data?.cuts||[],speakerNames:row?.data?.speakerNames||{}}} onRenameSpeaker={(speaker,name)=>onRenameSpeaker(row.id,speaker,name)} selected={selected} onSelect={select} onTogglePlayback={toggleCompactPlayback} onPreviewSelection={auditionSelection} addDisabled={busy} onSelectRange={ids=>{stop();setSelected(ids);setAnchor(source.words.findIndex(word=>word.id===ids[0]));}} currentTime={(playingId && playbackScope!=='selection') || previewSourceId!==sourceId ? -1 : currentTime} showRemoved={true} onShowRemovedChange={()=>{}} search={search} onSearch={setSearch} paperMode onAdd={()=>collectPassages(selected)} sourceId={sourceId} reviewProjectId={storyProjectId||activeId}/> : <div className={`panel interview-empty${row?.data?.transcriptionError?' is-transcription-failed':''}`} role={row?.data?.transcriptionError?'alert':undefined}>
           <h3>{row ? row.media_ready ? processingId===row.id ? 'Creating your transcript…' : row.data?.transcriptionError ? 'Transcription failed' : 'Your interview is ready' : 'Upload incomplete' : 'Your interviews go here'}</h3>
           <p>{row ? processingId===row.id ? processingText : row.data?.transcriptionError || (row.media_ready ? 'Transcribe it to start selecting passages and building your story.' : 'This video did not finish uploading. Re-import it, then remove the incomplete entry.') : 'Add an interview or choose one from this project’s interview list.'}</p>
           {row?.data?.transcriptionError&&<small className="transcription-failed-detail">Your video was uploaded successfully. The transcript was not created.</small>}
           {row?.media_ready ? (row.data?.transcriptionError && /no audio track|no spoken words|audio is too short|could not read this audio format/i.test(row.data.transcriptionError)
             ? <button className="add-interview-button" disabled={busy} onClick={onImport}>Upload a video with audio</button>
             : <button className="add-interview-button" disabled={busy} onClick={()=>onTranscribe(row.id)}>{processingId===row.id?'Transcribing…':row.data?.transcriptionError?'Retry transcription':'Transcribe interview'}</button>)
             : <button disabled={busy} onClick={onImport}>+ Add interview</button>}
          </div>}
        </>}
        </div>

      </div>
      <div className="paper-divider" role="separator" tabIndex={0} aria-label="Resize transcript and story" aria-orientation="vertical" aria-controls="paper-interview-pane" aria-valuemin={35} aria-valuemax={65} aria-valuenow={Math.round(split)} aria-valuetext={`${Math.round(split)} percent transcript width`} title="Drag to resize · Double-click to reset"
        onPointerDown={e=>{if(e.button!==0)return;e.preventDefault();resizing.current=true;e.currentTarget.setPointerCapture(e.pointerId);}}
        onPointerMove={e=>{if(resizing.current)resizeFromPointer(e);}}
        onPointerUp={e=>{resizing.current=false;if(e.currentTarget.hasPointerCapture(e.pointerId))e.currentTarget.releasePointerCapture(e.pointerId);}}
        onPointerCancel={()=>{resizing.current=false;}} onLostPointerCapture={()=>{resizing.current=false;}}
        onDoubleClick={()=>changeSplit(55)}
        onKeyDown={e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();changeSplit(e.key==='Home'?35:e.key==='End'?65:split+(e.key==='ArrowLeft'?-2:2));}}}><span /></div>
      <div className="paper-story panel is-compact-story" id="paper-story-pane" onKeyDown={event=>{
        if(!['Delete','Backspace'].includes(event.key) || event.ctrlKey || event.metaKey || event.altKey || event.nativeEvent.isComposing || event.target.closest('input,textarea,select,button,[contenteditable="true"],[role="textbox"]'))return;
        if(!event.target.closest('.paper-block') || !activeBlockId)return;
        event.preventDefault();event.stopPropagation();
        if(!event.repeat)removePassage(activeBlockId,true);
      }}>
        <div className="paper-story-heading">
          <div className="story-heading-main">
            {selectsCollapsed&&<button type="button" className="editor-reveal-tab"
              aria-label={feedbackOpen?'Show Feedback':'Show transcript'}
              title={feedbackOpen?'Reopen Feedback':'Reopen interview transcript'}
              onClick={()=>setSelectsCollapsed(false)}>
              <FiChevronLeft aria-hidden="true"/>
            </button>}
            <div className="story-heading-title">
              <div className="story-heading-line">
                <h3>Assembly</h3>
                <AssemblyCutSwitcher paper={paper} disabled={busy||safeFlowPreview||!activeId}
                  onBeforeSwitch={onBeforeCutSwitch} onHistory={()=>setHistoryOpen(true)}
                  onChange={next=>{
                    stop();closeFlow();setMarginOpen(null);setStorySelection(null);setSelectedStoryComment(null);
                    setActiveBlockId(null);setInsertBefore(null);setStoryFocus(null);setRecentlyAdded([]);
                    save(next);setAddedNotice('Working cut loaded');
                  }}/>
              </div>
              <div className="story-heading-meta">
                <span className="count">{paper.blocks.length} passages</span>
                <span className="story-heading-words">{storyRuntime(paper.blocks).words.toLocaleString()} words</span>
              </div>
              <small className="story-heading-status" role="status">{addedNotice || status || ''}</small>
            </div>
            <button type="button" className="story-play-edit" disabled={!paper.blocks.length}
              onClick={()=>playingId ? stop() : preview(paper.blocks,'story')}>
              {playingId ? '■ Stop playback' : '▶ Play edit'}
            </button>
            <button type="button" className="story-refine-header" disabled={busy||safeFlowPreview||!paper.blocks.length}
              onClick={onRefine} title="Refine Assembly cuts before exporting">
              <FiSliders aria-hidden="true"/><span>Refine cuts</span>
            </button>
            {!selectsCollapsed&&<button type="button" className="editor-pane-action hide-assembly"
              aria-label="Hide Assembly" title="Hide Assembly and enlarge interview transcript"
              onClick={()=>{setSelectsCollapsed(false);setAssemblyCollapsed(true);}}>
              <FiChevronRight aria-hidden="true"/>
            </button>}
          </div>
        </div>
        <div className={`paper-preview${previewCollapsed?' is-compact':''}`}>
          <div className="paper-preview-heading"><span className="paper-preview-label">{playingId ? `${playbackScope==='story'?'Playing assembly':playbackScope==='selection'?'Auditioning selection':'Playing selected passage'} · ${sourceName(previewSourceId)}` : `Interview preview · ${rows.find(item=>item.id===previewSourceId)?.data.filename || row?.data.filename || 'No interview selected'}`}</span>{!previewCollapsed&&<button type="button" className="preview-stats-toggle"
              aria-pressed={!statsCollapsed} aria-controls="paper-story-overview-panel"
              title={statsCollapsed?'Show Assembly Overview':'Hide Assembly Overview'}
              onClick={()=>setStatsCollapsed(value=>!value)}>
              <FiBarChart2 aria-hidden="true"/>
            </button>}<button type="button" className="preview-collapse-button" aria-expanded={!previewCollapsed} aria-controls="paper-preview-layout"
              title={previewCollapsed?'Expand video preview and Assembly stats':'Collapse video preview and Assembly stats to make more room for passages'}
              onClick={()=>setPreviewCollapsed(value=>!value)}>
              {previewCollapsed?<FiMaximize2 aria-hidden="true"/>:<FiMinimize2 aria-hidden="true"/>}
              
            </button>
            
           </div>
          <div id="paper-preview-layout" className={`paper-preview-layout${statsCollapsed?' is-stats-hidden':' is-overview-open'}`} hidden={previewCollapsed}>
          <div className="paper-monitor takefold-player" id="paper-video-picture" ref={playerFrame}>
            {previewError&&!url&&<div className="paper-preview-recovery" role="status" style={{position:'absolute',zIndex:3,inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:10,padding:18,background:'rgba(9,19,22,.91)',color:'#e8f2ee',textAlign:'center'}}>
              <strong>Video preview temporarily unavailable</strong>
              <span style={{maxWidth:360,fontSize:13,opacity:.85}}>Your Assembly edits are unaffected. Reconnect the interview preview.</span>
              <button type="button" onClick={retryPreview} disabled={busy}>Retry video</button>
            </div>}
            <video ref={video} src={url || (!activeId ? localUrl : undefined) || undefined}
              playsInline preload="metadata" disablePictureInPicture disableRemotePlayback
              controls={false} controlsList="nodownload noplaybackrate noremoteplayback"
              onPlay={()=>setNativePlaying(true)} onPause={()=>setNativePlaying(false)} onEnded={()=>setNativePlaying(false)}
              onEmptied={()=>{setMediaDuration(0);setNativePlaying(false);}}
              onLoadedMetadata={videoMetadataReady}
              onTimeUpdate={()=>{if(!playingId)setCurrentTime(video.current?.currentTime || 0);if(feedbackStopAt.current!==null&&video.current&&video.current.currentTime>=feedbackStopAt.current){video.current.pause();feedbackStopAt.current=null;}}}
              onError={recoverVideoError} />
            <div className="takefold-player-controls" role="group" aria-label="Video preview controls">
              <input type="range" className="takefold-player-scrubber"
                aria-label="Seek video" title={playingId?'Stop Assembly playback to seek in the interview':'Seek in interview'}
                aria-valuetext={`${formatTime(Math.min(currentTime,mediaDuration || currentTime))} of ${formatTime(mediaDuration)}`}
                min="0" max={mediaDuration||0} step="0.01"
                value={Math.min(currentTime,mediaDuration||0)}
                style={{'--player-progress':`${mediaDuration?100*Math.min(1,currentTime/mediaDuration):0}%`}}
                disabled={!!playingId||!mediaDuration}
                onChange={event=>seekPreview(Number(event.target.value))}/>
              <div className="takefold-player-controls-row">
                <button type="button" className="takefold-player-icon-btn" onClick={toggleCompactPlayback}
                  disabled={!url && !(localUrl&&!activeId)}
                  aria-label={playingId?'Stop Assembly playback':nativePlaying?'Pause video':'Play video'}
                  title={playingId?'Stop Assembly playback':nativePlaying?'Pause':'Play'}>
                  {playingId?<FiSquare aria-hidden="true"/>:nativePlaying?<FiPause aria-hidden="true"/>:<FiPlay aria-hidden="true"/>}
                </button>
                <span className="takefold-player-clock" aria-live="off">{formatTime(currentTime)} <span>/</span> {formatTime(mediaDuration)}</span>
                <span className="takefold-player-controls-spacer"/>
                <button type="button" className="takefold-player-icon-btn takefold-player-fullscreen"
                  onClick={toggleVideoFullscreen}
                  title={videoFullscreen?'Exit fullscreen':'Fullscreen video'}
                  aria-label={videoFullscreen?'Exit fullscreen':'Fullscreen video'}>
                  {videoFullscreen?<FiMinimize2 aria-hidden="true"/>:<FiMaximize aria-hidden="true"/>}
                </button>
              </div>
            </div>
          </div>
          <StoryOverview blocks={shownBlocks} sourceIds={colourSourceIds} sourceName={sourceName}
            selectedPassageId={activeBlockId} onJump={jumpToStoryPassage} hidden={statsCollapsed}/>
          </div>
          {previewCollapsed && <div className="paper-compact-transport" role="group" aria-label="Compact preview playback">
            <button type="button" disabled={!url && !(localUrl && !activeId)} onClick={toggleCompactPlayback}
              aria-label={playingId?'Stop Assembly playback':nativePlaying?'Pause source interview':'Play source interview'}
              title={playingId?'Stop Assembly playback':nativePlaying?'Pause source interview':'Play source interview'}>
              {playingId?<FiSquare aria-hidden="true"/>:nativePlaying?<FiPause aria-hidden="true"/>:<FiPlay aria-hidden="true"/>}
              <span>{playingId?'Stop edit':nativePlaying?'Pause source':'Play source'}</span>
            </button>
            <input type="range" aria-label="Interview playback position" aria-valuetext={`${formatTime(currentTime)} of ${formatTime(mediaDuration)}`} title={playingId?'Stop edited playback to scrub the interview':'Seek in source interview'} min="0" max={mediaDuration || 0} step="0.01" value={Math.min(currentTime,mediaDuration || 0)} disabled={!!playingId || !mediaDuration} onChange={e=>{const time=Number(e.target.value);if(video.current)video.current.currentTime=time;setCurrentTime(time);}}/>
            <span className="compact-time" title="Source interview time">{formatTime(currentTime)} / {formatTime(mediaDuration)}</span>
          </div>}
        </div>
        <div className="paper-source-legend story-source-toolbar" aria-label="Assembly sources and editing tools">
          <div className="story-source-key" aria-label="Interview colour key">
            {storyLegendIds.length>1&&<>
              <span className="paper-source-legend-title">SOURCES</span>
              <div className="paper-source-legend-items">{storyLegendIds.map(id=>
                <span className="paper-source-legend-item" key={id} style={interviewColour(id,colourSourceIds)}
                  title={`${sourceName(id)} · ${storySourceCounts.get(id)} passages`}>
                  <i aria-hidden="true"/><span>{sourceName(id)}</span>
                  <small>{storySourceCounts.get(id)}</small>
                </span>
              )}</div>
            </>}
          </div>
          <div className={`story-utility-toolbar${storyMoreOpen?' is-open':''}`} ref={storyMoreRef}>
            <button type="button" className="story-suggest-flow" disabled={busy||!signedIn||paper.blocks.length<2}
              aria-pressed={flowOpen}
              onClick={()=>{if(flowOpen)closeFlow();else{setFlowPreview(null);setFlowOpen(true);}}}
              title="Suggest a passage order with AI. Review the proposed changes before applying.">
              <span aria-hidden="true">✦</span> Suggest Flow
            </button>
            <button type="button" className="story-add-section" disabled={busy}
              onClick={addSection} title="Add an editable heading after the selected passage, or at the end">
              <FiPlus aria-hidden="true"/> Headings
            </button>
            <button type="button" className="story-utility-more"
              aria-label="Assembly tools" title="Assembly tools" aria-expanded={storyMoreOpen} aria-controls="story-utility-actions"
              onClick={()=>setStoryMoreOpen(open=>!open)}>
              <FiMoreHorizontal aria-hidden="true"/>
            </button>
            <div className="paper-story-tools story-utility-actions" id="story-utility-actions"
              onClickCapture={()=>setStoryMoreOpen(false)}>
              <button type="button" className="story-pdf-button" disabled={!paper.blocks.length}
                title="Download a printable Paper Edit PDF with headings, quotes and source timecodes" onClick={()=>{
                  try{
                    downloadFile(paperPdfFilename(projectTitle+(readAssemblyCuts(paper).items.length>1?' - '+activeCutName(paper):'')),buildPaperPdf(paperWithCurrentNames(),projectTitle),'application/pdf');
                    setAddedNotice('Paper Edit PDF downloaded');
                  }catch(e){onError('PDF export failed: '+e.message);}
                }}>↓ PDF</button>
            </div>
          </div>
        </div>
        {flowOpen&&<StoryFlowPanel paper={paper} getAccessToken={getAccessToken}
          onPreview={setFlowPreview}
          onApply={next=>{save(checkpointBeforeAiChange(paper,next,'AI Suggest Flow'));setAddedNotice('AI order applied · previous edit saved in History');}}
          onClose={closeFlow}/>}
        <div key={readAssemblyCuts(paper).activeId} data-working-cut={readAssemblyCuts(paper).activeId} className={`paper-blocks ${draggingId ? 'is-reordering' : ''} ${safeFlowPreview?'is-flow-preview':''}`}
          inert={safeFlowPreview?'':undefined} tabIndex={-1}
          aria-label={safeFlowPreview?'AI suggested order preview — apply or dismiss to resume editing':'Assembly passages'}
          onDragOver={event=>{
            if(!headingDrag.current || event.target!==event.currentTarget)return;
            event.preventDefault();event.dataTransfer.dropEffect='move';
            setDropIndex(paper.blocks.length);setHeadingDrop(null);
          }}
          onDrop={event=>{
            if(!headingDrag.current || event.target!==event.currentTarget)return;
            event.preventDefault();placeHeadingInGap(paper.blocks.length);
          }}>
          {!paper.blocks.length && <div className="empty-transcript"><h3>Your assembly starts here.</h3><p>Select text on the left and press E to add a passage. Choose other interviews to collect more, then drag passages into order.</p></div>}
          {shownBlocks.map((block,index)=><React.Fragment key={block.id}>{!safeFlowPreview&&<button type="button" className={`story-insert-slot${insertBefore===index?' is-active':''}`} disabled={busy||Boolean(draggingId)} aria-label={`Insert the next selected passage before passage ${index+1}`} aria-pressed={insertBefore===index} title={insertBefore===index?'Click to return to adding at end':'Insert next selection here'} onClick={()=>setInsertBefore(current=>current===index?null:index)}><span aria-hidden="true">+</span></button>}{!safeFlowPreview&&renderSections(index)}<article data-passage-id={block.id} style={interviewColour(block.sourceId,colourSourceIds)} tabIndex={0} aria-keyshortcuts="Space Enter" aria-label={`Passage ${index+1}: ${block.text}`} className={`paper-block ${activeBlockId===block.id?'selected':''} ${playingId===block.id?'playing':''} ${dropIndex===index?'drop-before':''} ${draggingId===block.id?'dragging':''} ${recentlyAdded.includes(block.id)?'just-added':''} ${safeFlowPreview&&paper.blocks[index]?.id!==block.id?'flow-moved':''}`}
            onPointerDown={event=>{
              // The card's free surface and speaker/number are draggable. Keep
              // transcript selection, comments, menus, duration and controls intact.
              if(event.target.closest('.paper-comment-text,.paper-ai-rationale,.paper-margin-comment-marker,.paper-margin-comment-popover,.paper-selection-comment,.paper-block-duration,button:not(.passage-grip),input,textarea,select,a,summary,details,[contenteditable="true"]'))return;
              // Touch scrolling on the card remains natural; use the grip for touch reorder.
              if(event.pointerType==='touch'&&!event.target.closest('.passage-grip'))return;
              beginPassagePointer(event,index,block.id);
            }}
            onPointerMove={movePassagePointer}
            onPointerUp={event=>endPassagePointer(event)}
            onPointerCancel={event=>endPassagePointer(event,true)}
            onLostPointerCapture={event=>endPassagePointer(event,true)}
            onMouseUp={event=>captureStorySelection(event,block)}
            onTouchEnd={event=>{const card=event.currentTarget;requestAnimationFrame(()=>{if(card.isConnected)captureStorySelection({currentTarget:card},block);});}}
            onClick={event=>{setActiveBlockId(block.id);if(!event.target.closest('button,input,select,textarea')&&!window.getSelection()?.toString().trim())event.currentTarget.focus({preventScroll:true});}} onFocus={()=>setActiveBlockId(block.id)}
            onKeyDown={e=>{
              if(e.target!==e.currentTarget)return;
              if(e.altKey && ['ArrowUp','ArrowDown'].includes(e.key)){
                e.preventDefault();const to=index+(e.key==='ArrowUp'?-1:1);
                if(to>=0 && to<paper.blocks.length)reorder(index,to);
              }else if(isStoryPassageSpace(e,e.currentTarget)){
                // Story focus owns Space. Don't trigger the global interview
                // playback shortcut, scroll the page, or repeat-toggle on hold.
                e.preventDefault();e.stopPropagation();
                if(playingId && playbackScope==='story')stop();
                else preview(assemblyFromPassage(paper.blocks,block.id),'story');
              }else if(e.key==='Enter'){
                // Enter retains the single-passage audition shortcut.
                e.preventDefault();preview([block],'passage');
              }
            }}
            onDragOver={e=>{
              if(!headingDrag.current)return;
              e.preventDefault();e.dataTransfer.dropEffect='move';
              const rect=e.currentTarget.getBoundingClientRect();
              const insertion=index+(e.clientY>rect.top+rect.height/2?1:0);
              setDropIndex(previous=>previous===insertion?previous:insertion);
              setHeadingDrop(null);
            }}
            onDrop={e=>{
              if(!headingDrag.current)return;
              e.preventDefault();
              const rect=e.currentTarget.getBoundingClientRect();
              const insertion=index+(e.clientY>rect.top+rect.height/2?1:0);
              placeHeadingInGap(insertion);
            }}>
            <header><button className="passage-grip" type="button"
              aria-label={`Drag passage ${index+1} to reorder; Alt plus up or down arrow to reorder by keyboard`}
              title="Drag to reorder · Alt + ↑/↓ to move"
              onKeyDown={event=>{
                if(event.altKey&&['ArrowUp','ArrowDown'].includes(event.key)){
                  event.preventDefault();event.stopPropagation();
                  const to=index+(event.key==='ArrowUp'?-1:1);
                  if(to>=0&&to<paper.blocks.length)reorder(index,to);
                }
              }}><svg width="20" height="24" viewBox="0 0 20 24" aria-hidden="true" focusable="false">{[5,12,19].flatMap(y=>[6,14].map(x=><circle key={`${x}-${y}`} cx={x} cy={y} r="1.7" fill="currentColor"/>))}</svg></button><strong><span className="paper-block-index">{String(index+1).padStart(2,'0')}</span><span className="paper-block-source" title={sourceName(block.sourceId)}>{sourceName(block.sourceId)}</span></strong>{safeFlowPreview&&paper.blocks[index]?.id!==block.id&&<span className="story-flow-was">was #{paper.blocks.findIndex(item=>item.id===block.id)+1}</span>}<span className="paper-block-duration">{formatTime(block.end-block.start)}</span><button className="passage-comment-button" type="button" disabled={busy} aria-label={`Comment on passage ${index+1}`} title="Comment on this passage" onClick={event=>{event.stopPropagation();setMarginOpen(marginOpen===block.id?null:block.id);setStoryFocus(null);setSelectedStoryComment(null);}}><FiMessageCircle aria-hidden="true"/>{(storyOpenCommentCounts.get(block.id)||0)>0&&<span>{storyOpenCommentCounts.get(block.id)}</span>}</button><button className="passage-delete" disabled={busy} aria-label={`Remove passage ${index+1} from edit`} title="Remove passage · Undo to restore" onClick={event=>{event.stopPropagation();removePassage(block.id,true);}}><FiTrash2 aria-hidden="true"/></button></header>
            <p className="paper-comment-text">{(()=>{
              const selected=storyCommentsById.get(selectedStoryComment);
              const active=selected?.block_id===block.id?selected:null;
              const match=storyExcerpt(block.text,active);
              if(!match){
                // Only the playing passage needs word spans. Match the original
                // source snapshot exactly so punctuation/edited quotes never drift.
                if(playingId===block.id && playbackScope==='story'){
                  const timed=(paper.sources?.[block.sourceId]?.words||[]).filter(word=>word.start<block.end && word.end>block.start);
                  if(timed.length && timed.map(word=>word.text).join(' ')===block.text){
                    return timed.map((word,i)=><React.Fragment key={word.id||i}><span className={`paper-follow-word${currentTime>=word.start && currentTime<word.end?' is-speaking':''}`}>{word.text}</span>{i<timed.length-1?' ':''}</React.Fragment>);
                  }
                }
                return block.text;
              }
              const letters=chars(block.text);
              return <>{letters.slice(0,match.start).join('')}<mark className="paper-comment-highlight comment-anchored-highlight">{letters.slice(match.start,match.end).join('')}</mark>{letters.slice(match.end).join('')}</>;
            })()}{activeBlockId===block.id&&<button type="button" className="paper-show-in-transcript" disabled={busy} title="Find this passage in the source transcript" onClick={event=>{event.stopPropagation();showInTranscript(block);}}>Show in transcript <FiArrowUpRight aria-hidden="true"/></button>}</p>
            {block.editorialReason&&<details className="paper-ai-rationale"><summary>{({beginning:'Beginning',middle:'Middle',end:'End'})[block.editorialSection]||'AI edit'} · Why this passage?</summary><p>{block.editorialReason}</p>{block.editorialContext&&<p><strong>Check:</strong> {block.editorialContext}</p>}</details>}
             {block.editorialFlowReason&&<details className="paper-ai-rationale"><summary>AI flow · Why this position?</summary><p>{block.editorialFlowReason}</p></details>}
            <div className="paper-margin-comment-marker">
              <button type="button"
                className={storyCommentsByBlock.has(block.id) ? 'has-comments' : 'is-add-comment'}
                title={storyCommentsByBlock.has(block.id)?'Read comments on this passage':'Add a comment to this passage'}
                aria-label={storyCommentsByBlock.has(block.id)
                  ? `${storyCommentsForBlock(block.id).length} comments on Story passage ${index+1}`
                  : `Add comment to Story passage ${index+1}`}
                aria-expanded={marginOpen===block.id} onClick={e=>{
                  e.stopPropagation();
                  if(marginOpen===block.id){setMarginOpen(null);setStoryFocus(null);setSelectedStoryComment(null);return;}
                  if(!storyCommentsByBlock.has(block.id)){
                    // Empty passage: one click goes directly to the comment editor.
                    beginStoryComment(block,storySelection?.blockId===block.id?storySelection:null);
                  }else{
                    // Immediately mark the linked quote, even before the thread
                    // finishes loading. The annotation never changes the edit.
                    const notes=storyCommentsForBlock(block.id);
                    const latest=[...notes].sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))
                      .find(note=>note.status==='open')||notes.at(-1);
                    setStoryFocus(null);setSelectedStoryComment(latest?.id||null);setMarginOpen(block.id);
                  }
                }}>
                <FiMessageCircle aria-hidden="true"/>
                {storyCommentsByBlock.has(block.id)
                  ? <span>{storyCommentsForBlock(block.id).length}</span>
                  : <span className="paper-margin-add-plus" aria-hidden="true">+</span>}
              </button>
            </div>
            {marginOpen===block.id&&<div className="paper-margin-comment-popover" onClick={e=>e.stopPropagation()} onKeyDown={e=>{if(e.key==='Escape'){e.stopPropagation();setMarginOpen(null);setStoryFocus(null);}}}>
              <div className="paper-margin-popover-heading"><strong>Passage {index+1} comments</strong><button type="button" aria-label="Close comments" onClick={()=>{setMarginOpen(null);setStoryFocus(null);setSelectedStoryComment(null);}}>×</button></div>
              <StoryCommentsPanel compact blockId={block.id} projectId={storyProjectId||activeId}
                focus={storyFocus?.blockId===block.id?storyFocus:null} onClear={()=>setStoryFocus(null)}
                onData={setStoryComments} onNavigate={navigateStoryComment} openCommentId={selectedStoryComment} onCreate={()=>beginStoryComment(block)} disabled={busy}/>
            </div>}
            {storySelection?.blockId===block.id&&<button className="paper-selection-comment" type="button" style={{left:storySelection.left,top:storySelection.top}} onPointerDown={event=>event.preventDefault()} onClick={event=>{event.stopPropagation();beginStoryComment(block,storySelection);}}><FiMessageCircle/> Comment</button>}
          </article></React.Fragment>)}
          {!safeFlowPreview&&paper.blocks.length>0&&<button type="button" className={`story-insert-slot story-insert-end${insertBefore===paper.blocks.length?' is-active':''}`} aria-label="Insert next selection at end of Assembly" aria-pressed={insertBefore===paper.blocks.length} disabled={busy||Boolean(draggingId)} title="Add next selection at end" onClick={()=>setInsertBefore(null)}><span aria-hidden="true">+</span></button>}
          {!safeFlowPreview&&renderSections(paper.blocks.length)}
          {dropIndex===paper.blocks.length && draggingId && <div className="paper-drop-end" aria-hidden="true" />}

        </div>
        <StoryRuntimeBar gauge blocks={paper.blocks} target={selectedRuntime} onSetTarget={setRuntimeTarget}/>
      </div>
    </div>

    </div>
    {historyOpen&&<AssemblyCutHistory paper={paper} disabled={busy} onClose={()=>setHistoryOpen(false)}
      onChange={next=>{
        save(next);setMarginOpen(null);setStorySelection(null);setSelectedStoryComment(null);
        setActiveBlockId(null);setAddedNotice('Earlier Assembly recovered · Previous edit backed up in History');
      }}/>}

    <StoryDraft open={storyDraftOpen} onClose={()=>setStoryDraftOpen(false)} rows={rows}
      rootId={activeId} paper={paper} getAccessToken={getAccessToken}
      onUse={async next=>{
        const oldIds=new Set(paper.blocks.map(part=>part.id));
        const freshIds=next.blocks.filter(part=>!oldIds.has(part.id)).map(part=>part.id);
        let adjusted=next;
        if(waveformAssistEnabled&&freshIds.length){
          adjusted=await assistWaveformPassages(next,freshIds,sourceId=>{
            const target=interviews.find(item=>item.id===sourceId&&item.media_ready);
            if(!target)throw new Error('Source video unavailable.');
            return mediaUrl(target);
          });
        }
        if(latestEdit.current?.project!==project)throw new Error('Assembly changed while checking audio. Please apply the draft again.');
        save(checkpointBeforeAiChange(paper,adjusted,'AI Complete Story'));
        setAddedNotice('AI recovery saved · Open History to restore');
      }}
      onLocate={(passage,draftSource)=>{
        if(!draftSource){onError('This interview is no longer available.');return;}
        const first=draftSource.words[passage.start],last=draftSource.words[passage.end];
        if(first&&last)showInTranscript({sourceId:draftSource.id,start:first.start,end:last.end});
      }}/>
  </section>;
}
